import { useState } from "react";
import { ArrowUpRight } from "lucide-react";
import { SUBSTACK_URL } from "@/lib/api";
import { FadeUp } from "@/components/Reveal";

export default function SubstackCTA() {
  const [email, setEmail] = useState("");

  const subscribe = (e) => {
    e.preventDefault();
    const url = email
      ? `${SUBSTACK_URL}/subscribe?email=${encodeURIComponent(email)}`
      : SUBSTACK_URL;
    window.open(url, "_blank", "noopener,noreferrer");
  };

  return (
    <section data-testid="substack-cta" className="bg-paper">
      <div className="max-w-[1600px] mx-auto px-5 sm:px-8 lg:px-12 py-24 lg:py-28 grid lg:grid-cols-12 gap-12 items-center">
        <FadeUp className="lg:col-span-6">
          <p className="label text-ink/50 mb-5">The Newsletter · on Substack</p>
          <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl tracking-tight leading-[0.95]">
            Get the reporting in your inbox.
          </h2>
          <p className="mt-6 text-lg text-ink/70 leading-relaxed max-w-lg">
            Dispatches, analysis, and community storytelling from The Canary Report — delivered
            free through Substack.
          </p>
        </FadeUp>

        <FadeUp delay={0.1} className="lg:col-span-5 lg:col-start-8">
          <form onSubmit={subscribe} data-testid="substack-form" className="flex flex-col sm:flex-row border border-ink">
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              data-testid="substack-email"
              placeholder="you@email.com"
              className="flex-1 bg-white px-5 py-4 font-sans outline-none placeholder:text-ink/40"
            />
            <button
              type="submit"
              data-testid="substack-subscribe-btn"
              className="label bg-ink text-white px-8 py-4 hover:bg-canary hover:text-ink transition-colors duration-300 flex items-center justify-center gap-2"
            >
              Subscribe <ArrowUpRight size={16} />
            </button>
          </form>
          <a
            href={SUBSTACK_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="substack-visit-link"
            className="inline-block mt-4 label text-ink/50 hover:text-ink link-underline pb-1"
          >
            Read on Substack →
          </a>
        </FadeUp>
      </div>
    </section>
  );
}
